<template>
    <div :class="{ 'bb-card-wrapper': true, 'is-preview': isPreview }">
        <div class="bb-card-overlay" v-if="isPreview" @click="addRow">
            <div class="d-flex justify-content-around align-items-center h-100">
<!--                <div class="alert alert-warning">Click to add another item</div>-->
                <div class="m-0 py-1 px-3 bb-card-overlay-text btn btn-outline-primary rounded-pill shadow">Add colors & sizes to design</div>
            </div>
        </div>
        <div class="card bb-card mb-4">
            <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <a @click="removeRow(position)" v-if="customband.hasMultipleItems()"><i class="icon-spot fas fa-trash mr-2"></i></a>
                        <h5 class="m-0">Item {{ position + 1 }}</h5>
                    </div>

                    <div class="d-flex justify-content-between align-items-center">
          <span class="mr-2" v-if="customband.hasMultipleItems()">
            <v-switch
                    class="m-0"
                    :input-value="isActive"
                    label="Preview"
                    hide-details
                    @change="selectRow(position)"></v-switch>
          </span>
                    </div>


                    <!--<div class="form-check">-->
                    <!--<input class="form-check-input" :id="'radio_'+position" type="radio" name="band" :value="customband.customization.selected" @click="selectRow(position)" :checked="position === customband.customization.selected"/>-->
                    <!--<label class="form-check-label" :for="'radio_'+position">Item {{ position + 1 }}</label>-->
                    <!--</div>-->
                </div>
            </div>
            <div class="card-body pb-0">
                <div class="row">
                    <div class="col-lg-auto">
                        <v-select

                                :items="customband.product.variants"
                                label="Size"
                                outline
                                menu-props="auto"
                                item-text="name"
                                :value="row.variant"
                                return-object
                                @input="setVariant"
                                :rules="[rules.required]"
                                :hint="`<a href='${sizingGuide}' target='_blank'>Sizing Guide</a>`"
                                persistent-hint
                        >
                            <template slot="item" slot-scope="data">
                                <a>{{ data.item.name }}<span v-if="data.item.name == 'Child'">&nbsp;<sup class="footnote">&dagger;</sup></span></a>
                            </template>
                        </v-select>
                    </div>
                    <div class="col-lg" v-if="!(position !== 0 && customband.isMultiColor())">
                        <colors-select :colors="customband.getProductColors()" :color-value="row.color1" :color-required="true" label="Color" :show-label="true" :is-print-color="false" />

                        <colors-select :colors="customband.getProductColors()" :color-value="row.color2" :color-required="true" v-if="customband.product.manifest.colorContainers.color_1 && customband.product.manifest.type != 'Dual Layer'" label="Color 2" :show-label="true" :is-print-color="false" />

                        <colors-select :colors="customband.getProductColors()" :color-value="row.color3" :color-required="true" v-if="customband.product.manifest.colorContainers.color_2 && customband.product.manifest.type != 'Dual Layer'" label="Color 3" :show-label="true" :is-print-color="false" />
                    </div>
                    <div class="col-lg" v-if="customband.hasAllTheSamePrintColors() && (customband.getPrintColors().length > 0)">
                        <colors-select :colors="customband.getPrintColors()" :color-value="rowColorFillValue" :color-required="customband.isPrinted()" label="Print Color" :show-label="true" :is-print-color="true" :is-global="true" :row-position="position" />
                    </div>
                    <div class="col-lg">
                        <v-text-field
                                label="Quantity"
                                :value="row.qty"
                                outline
                                :rules="[rules.required, rules.positive, rules.moq]"
                                @input="changeQty"
                        ></v-text-field>
                    </div>
                </div>
            </div>
            <div class="card-footer pt-0" v-if="!isPreview">
                <div class="item-price-cont d-flex justify-content-end align-items-center">
                    <label class="m-0">Subtotal:</label>
                    <span class="item-price ml-2 text-right"><span v-if="price > 0">{{ price | currency }}</span><span v-if="price <= 0">N/A</span></span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">

    .bb-card-wrapper {
      position: relative;
      .bb-card-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        cursor: pointer;
        .bb-card-overlay-text {
          font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif !important;
          font-weight: bold;
          font-size: 1.4em;
          text-transform: uppercase;
          background-color: #ffffff;
          //color: #ffffff;
          //text-shadow: 3px 2px 0 #7a7a7a;
          &:hover {
            background-color: #116abf;
            border-color: #116abf;
            //color: #ffc107;
          }
        }
      }
    }

    .is-preview {
      .bb-card {
        filter: grayscale(1);
        opacity: .2;
        pointer-events: none;
      }
    }

</style>

<script>
  import { mapState } from 'vuex'
  import _get from 'lodash/get'
  import _debounce from 'lodash/debounce'

  let stateName = 'bandbuilder.silicone.style'

  export default {
    props: ['row', 'position', 'isPreview'],
    data () {
      return {
        showVisibleTooltip: false,
        sizingGuide: window.RB.sizing_guide,
        sizeDialog: false,
        rules: {
          required: value => !!value || 'Required.',
          positive: v => v > 0 || 'Only positive numbers',
          moq: v => v >= this.moq || `Minimum quantity is ${this.moq}`
        }
      }
    },
    computed: {
      variantName () {
        return _get(this.row, 'variant.name', '')
      },
      isActive () {
        return this.customband.customization.selected === this.position
      },
      moq () {
        return this.customband.getMinimumOrderQuantity()
      },
      price () {
        let price = ''
        let rowQty = _get(this.customband, `customization.rows.${this.position}.qty`, 0)

        if (typeof this.row.variant !== 'undefined') {
          if (rowQty >= this.moq) {
            // Get row subtotal
            price = this.customband.getPricePerBand(rowQty, this.row.variant)
          }
        }

        if (rowQty < this.moq) {
          price = 'N/A'
        }

        return price
      },
      rowColorFillValue () {
        return this.row.colorFill
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband'
      ])
    },
    methods: {
      setVariant (variant) {
        let payload = {
          rowIndex: this.position,
          variant
        }
        this.$store.commit('customband/setVariant', payload)
        this.$store.dispatch('customstates/stepIsDirty', stateName)
        this.$store.dispatch('customband/checkCompletion')
      },
      selectRow (rowIndex) {
        this.$store.dispatch('customband/selectRow', rowIndex)
        this.$store.dispatch('customstates/stepIsDirty', stateName)
        this.$store.dispatch('customband/checkCompletion')
        this.$root.$data.fixedPreview.renderProduct()
      },
      removeRow (rowIndex) {
        this.$store.dispatch('customband/removeRow', rowIndex)
        this.$store.dispatch('customstates/stepIsDirty', stateName)
        this.$store.dispatch('customband/checkCompletion')
        this.$root.$data.fixedPreview.renderProduct()
      },

      addRow () {
        this.$store.commit('customband/addRow')
        this.$root.$data.fixedPreview.renderProduct()
      },

      changeQty: _debounce(function (qty) {
        let payload = {
          rowIndex: this.position,
          qty: qty
        }
        this.$store.commit('customband/setQty', payload)
        this.$store.dispatch('customstates/stepIsDirty', stateName)
        this.$store.dispatch('customband/checkCompletion')
      }, 500)
    },
    created () {
      // console.log('this.row', this.row)
    }
  }
</script>
